/**
 * Stable CSS class names for E2E — Order detail drawer content.
 */
export const OODDC = {
    root: 'order-detail-drawer-content',
    headerRoot: 'order-detail-drawer-content__header',
    headerTitle: 'order-detail-drawer-content__header-title',
    headerCloseIcon: 'order-detail-drawer-content__header-close-icon',
    section: 'order-detail-drawer-content__section',
    pair: 'order-detail-drawer-content__pair',
    title: 'order-detail-drawer-content__pair-title',
    value: 'order-detail-drawer-content__pair-value',
    orderInformationTitle: 'order-detail-drawer-content__order-information-title',
    shippingInformationTitle: 'order-detail-drawer-content__shipping-information-title',
    // rows
    rowOrderNumber: 'order-detail-drawer-content__row-order-number',
    rowOrderDate: 'order-detail-drawer-content__row-order-date',
    rowCost: 'order-detail-drawer-content__row-cost',
    rowStoreCode: 'order-detail-drawer-content__row-store-code',
    rowSellerName: 'order-detail-drawer-content__row-seller-name',
    rowPlatform: 'order-detail-drawer-content__row-platform',
    rowOrderStatus: 'order-detail-drawer-content__row-order-status',
    rowLastStatusUpdateDate: 'order-detail-drawer-content__row-last-status-update-date',
    rowShippingNo: 'order-detail-drawer-content__row-shipping-no',
    rowShippingStatus: 'order-detail-drawer-content__row-shipping-status',
    rowCargoCompany: 'order-detail-drawer-content__row-cargo-company',
} as const;

